import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA support with update detection
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('✅ PWA: Service Worker registered:', registration);
        
        // Check for updates every 5 minutes
        setInterval(() => {
          registration.update();
        }, 5 * 60 * 1000);
        
        // Listen for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New version available
              if (window.confirm('New version of Mind My Mojo is available! Update now?')) {
                newWorker.postMessage({ type: 'SKIP_WAITING' });
                window.location.reload();
              }
            }
          });
        });
      })
      .catch((error) => {
        console.log('❌ PWA: Service Worker registration failed:', error);
      });
    
    // Force reload from server when app gains focus (clears cache)
    let isReloading = false;
    window.addEventListener('focus', () => {
      if (!isReloading && navigator.onLine) {
        isReloading = true;
        // Check if there's a new version by fetching index.html
        fetch('/index.html', { cache: 'no-store' })
          .then(() => {
            // Optionally: Could compare versions here
            isReloading = false;
          })
          .catch(() => {
            isReloading = false;
          });
      }
    });
  });
}
